import React from 'react';
import log from "../../helpers/log";
import PlayVideo from '../../helpers/PlayVideo'
import GfywElement from './GfywElement.jsx';



class GfywList extends React.Component {
	
	componentDidMount(){
		new PlayVideo();
	}
	componentWillUnmount(){
		$('.hasVideo').unbind();
	}
	componentDidUpdate(){
		$('.hasVideo').unbind();
		new PlayVideo();
	}
	render () {
		var rows = [];
		
		this.props.data.forEach((result,key) =>  {
			rows.push(<GfywElement key={key} {...result}  /> );
		});
		return (
				<ul>
					{rows}
				</ul>
			)
	}
}
export default GfywList;
